window.CHARGER = {
    layers: {
        cross: $('#charger-window .cross'),
        window: $('#charger-window'),
        am_description_text: $('#charger-window .electro_description .message'),
        gmap: $('#gmap'),
        book: {
            book_connector_btn: $('#charger-window .charger-content .connectors .connector .description .line2 .btns button.book'),
            window: $('#book-connector'),
            cross: $('#book-connector .book-connector-title .cross'),
            types: {
                min15: $('#book-connector .book-connector-content .item.min15'),
                min30: $('#book-connector .book-connector-content .item.min30'),
                min45: $('#book-connector .book-connector-content .item.min45'),
                hour1: $('#book-connector .book-connector-content .item.hour1'),
                min15_free_count: $('#book-connector .book-connector-content .item.min15 .free-count'),
                min15_btn: $('#book-connector .book-connector-content .item.min15 .line3 button'),
                min30_btn: $('#book-connector .book-connector-content .item.min30 .line3 button'),
                min45_btn: $('#book-connector .book-connector-content .item.min45 .line3 button'),
                hour1_btn: $('#book-connector .book-connector-content .item.hour1 .line3 button'),
                min30_price: $('#book-connector .book-connector-content .item.min30 .line2 span'),
                min45_price: $('#book-connector .book-connector-content .item.min45 .line2 span'),
                hour1_price: $('#book-connector .book-connector-content .item.hour1 .line2 span')
            },
            active_btn: $('#book-connector .book-connector-content .item .line3 button')
        },

        btn: {
            start_charging: $('#charger-window .charger-content .connectors .connector .description .line2 .btns button.start-charging'),
            book: $('#charger-window .charger-content .connectors .connector .description .line2 .btns button.book')
        },

        add_review: {
            window: $('#transaction-review'),
            cross: $('#transaction-review .transaction-review-title .cross'),
            rating_star: $('#transaction-review .transaction-review-content .block form .rating .star'),
            rating_star_select: '#transaction-review .transaction-review-content .block form .rating .star',
            form: $('#transaction-review .transaction-review-content .block form'),
            comment: $('#add-comment-text')
        },

        add_comment: {
            window: $('#charger-comment'),
            cross: $('#charger-comment .charger-comment-title .cross'),
            rating_star: $('#charger-comment .charger-comment-content .block form .rating .star'),
            rating_star_select: '#charger-comment .charger-comment-content .block form .rating .star',
            form: $('#charger-comment .charger-comment-content .block form'),
            add_comment_btn: $('#charger-window .charger-content .comments .title .add-comment-btn'),
            text: $('#charger-comment .charger-comment-content .block form textarea'),
            submit_btn: $('#charger-comment .charger-comment-content .block form button')
        },

        charger: {
            tariff_block: {
                block: $('#charger-window .charger-content .tariff-block'),
                icon: $('#charger-window .charger-content .tariff-block .icon'),
                content: $('#charger-window .charger-content .tariff-block .tariff-block-content'),
                text: $('#charger-window .charger-content .tariff-block .text')
            },
            name: $('#charger-window .header .title'),
            icon: $('#charger-window .header .icon'),
            adress: $('#charger-window .charger-content .adress .text'),
            map_link: $('#charger-window .charger-content .adress .btns .uk-button.map-link'),
            service: $('#charger-window .charger-content .info-box.service'),
            phase_imbalance: $('#charger-window .charger-content .info-box.phase_imbalance'),
            working_time: $('#charger-window .charger-content .time .text'),
            rfid: $('#charger-window .charger-content .rfid'),
            chip_auth: $('#charger-window .charger-content .ae-chip'),
            night_tariff: $('#charger-window .charger-content .night'),
            subnetwork: {
                block: $('#charger-window .charger-content .subnetwork'),
                name: $('#charger-window .charger-content .subnetwork .title'),
                logo: $('#charger-window .charger-content .subnetwork .icon .logo'),
                icon: $('#charger-window .charger-content .subnetwork .icon')
            },
            photo: {
                block: $('#charger-window .charger-content .photo'),
                photo: $('#charger-window .charger-content .photo .slider ul'),
            },
            comments: {
                list: $('#charger-window .charger-content .comments ul'),
                empty: $('#charger-window .charger-content .comments .empty')
            },

            chinaoffline: $('#charger-window .charger-content .info-box.chinaoffline'),
            emergency_btn: $('#charger-window .charger-content .info-box.emergencybtn'),
            access: $('#charger-window .charger-content .info-box.access'),
            access_text: $('#charger-window .charger-content .info-box.access .access-text'),
            messages: $('#charger-window .charger-content .info-box')
        },

        load: $('#load')
    },

    timer: {
        start_transaction: false
    },

    open_window: function (charger_id) {

        if(!window.CHARGER.layers.load.hasClass('active')) {
            window.CHARGER.layers.load.addClass('active');
        }

        window.WS.getChargerInfo(charger_id);
    },

    show_info: function (data) {
        window.CHARGER.layers.charger.name.html(data.name);
        window.CHARGER.layers.charger.adress.html(data.address);

        window.CHARGER.layers.charger.icon.removeClass('connected');
        window.CHARGER.layers.charger.icon.removeClass('disconnected');
        window.CHARGER.layers.charger.icon.removeClass('offline');
        window.CHARGER.layers.charger.icon.addClass(data.status);

        window.CHARGER.layers.add_comment.add_comment_btn.attr('data-id', data.pk);

        window.CHARGER.layers.charger.map_link.attr('href', "https://www.google.com/maps/dir/?api=1&destination="+ data.gps.lat +","+ data.gps.lon);

        if(data.in_service == '1') {
            if(window.CHARGER.layers.charger.service.hasClass('hide')) {
                window.CHARGER.layers.charger.service.removeClass('hide');
            }
        } else {
            if(!window.CHARGER.layers.charger.service.hasClass('hide')) {
                window.CHARGER.layers.charger.service.addClass('hide');
            }
        }

        if(data.phase_imbalance == '1') {
            if(window.CHARGER.layers.charger.phase_imbalance.hasClass('hide')) {
                window.CHARGER.layers.charger.phase_imbalance.removeClass('hide');
            }
        } else {
            if(!window.CHARGER.layers.charger.phase_imbalance.hasClass('hide')) {
                window.CHARGER.layers.charger.phase_imbalance.addClass('hide');
            }
        }

        var working_time_layer = window.CHARGER.layers.charger.working_time.closest('.time');
        if(data.working_time != '') {
            window.CHARGER.layers.charger.working_time.html(data.working_time);

            if(working_time_layer.hasClass('hide')) {
                working_time_layer.removeClass('hide');
            }
        } else {
            if(!working_time_layer.hasClass('hide')) {
                working_time_layer.addClass('hide');
            }
        }

        if(data.rfid == 'on') {
            if(window.CHARGER.layers.charger.rfid.hasClass('hide')) {
                window.CHARGER.layers.charger.rfid.removeClass('hide');
            }
        } else {
            if(!window.CHARGER.layers.charger.rfid.hasClass('hide')) {
                window.CHARGER.layers.charger.rfid.addClass('hide');
            }
        }

        if(data.chip_auth == '1') {
            if(window.CHARGER.layers.charger.chip_auth.hasClass('hide')) {
                window.CHARGER.layers.charger.chip_auth.removeClass('hide');
            }
        } else {
            if(!window.CHARGER.layers.charger.chip_auth.hasClass('hide')) {
                window.CHARGER.layers.charger.chip_auth.addClass('hide');
            }
        }

        if(data.is_night_tariff == '1') {
            if(window.CHARGER.layers.charger.night_tariff.hasClass('hide')) {
                window.CHARGER.layers.charger.night_tariff.removeClass('hide');
            }
        } else {
            if(!window.CHARGER.layers.charger.night_tariff.hasClass('hide')) {
                window.CHARGER.layers.charger.night_tariff.addClass('hide');
            }
        }

        $('#charger-window .charger-content .connectors .connector').each(function () {
           if(!$(this).hasClass('hide')) {
               $(this).addClass('hide');
           }
        });

        let one_electro_price = 50;
        $.each(data.connectors, function (pk, connector) {
            var connector_html = $('#charger-window .charger-content .connectors .connector[data-key='+ connector.id +']');
            if(connector.tariff_details.day.tariff_per_kWh > one_electro_price) {
                one_electro_price = connector.tariff_details.day.tariff_per_kWh;
            }

            /* icon */
            var icon = connector_html.find('.icon');

            var types = ['type1', 'type2', 'chademo', 'ccs1', 'ccs2', 'gbt'];
            $.each(types, function (index, type) {
                if(icon.hasClass(type)) {
                    icon.removeClass(type);
                }
            });

            icon.addClass(connector.type.base);
            /* end icon */

            /* title */
            var title = connector_html.find('.description .line1 .title');

            if(connector.type.name != connector.type.stand) {
                title.html(connector.type.name + ' <span>(' + connector.type.stand + ')</span>');
            } else {
                title.html(connector.type.name);
            }
            /* end title */

            /* status */
            var status = connector_html.find('.description .line1 .status');
            status.html(connector.status.name);
            /* end status */

            /* ampere */
            var ampere = connector_html.find('.description .line2 .ampere');
            ampere.html(connector.ampere_max + 'A');
            /* end status */

            /* max_power */
            var max_power = connector_html.find('.description .line2 .power');
            max_power.html("("+ connector.max_power+ ")");
            /* end status */

            /* tariff */
            var tariff = connector_html.find('.description .line2 .tariff span.value');
            tariff.html(connector.tariff);
            /* end tariff */

            /* buttons */
            var button = {
                soc: connector_html.find('.description .line2 .btns .charging-percent'),
                start_charging: connector_html.find('.description .line2 .btns .start-charging'),
                book: connector_html.find('.description .line2 .btns .book'),
                booked: connector_html.find('.description .line2 .btns .booked'),
                stop_transaction: connector_html.find('.description .line2 .btns .stop-transaction')
            };

            var bookmark = connector_html.find('.number .book-icon');
            if(!bookmark.hasClass('hide')) {
                bookmark.addClass('hide');
            }

            if(!button.soc.hasClass('hide')) {
                button.soc.addClass('hide');
            }
            if(!button.start_charging.hasClass('hide')) {
                button.start_charging.addClass('hide');
            }

            if(button.book.length > 0) {
                if (!button.book.hasClass('hide')) {
                    button.book.addClass('hide');
                }
            }
            if(!button.booked.hasClass('hide')) {
                button.booked.addClass('hide');
                button.booked.find('span').html('');
            }
            if(!button.stop_transaction.hasClass('hide')) {
                button.stop_transaction.addClass('hide');
            }

            if(button.start_charging.prop('disabled') == false) {
                button.start_charging.prop('disabled', true);
            }
            if(button.book.length > 0) {
                if (button.book.prop('disabled') == false) {
                    button.book.prop('disabled', true);
                }
            }
            if(button.booked.prop('disabled') == false) {
                button.booked.prop('disabled', true);
            }

            switch (connector.status.base) {
                case "Available":

                    button.start_charging.removeClass('hide');
                    if (button.book.length > 0) {
                        button.book.removeClass('hide');
                    }

                    if(data.in_service == "0") {
                        if (window.user_balance >= window.min_balance) {
                            button.start_charging.attr('data-connector', connector.pk);
                            button.start_charging.attr('data-charger', data.pk);

                            if (button.book.length > 0) {
                                button.book.attr('data-connector', connector.pk);
                            }
                        }

                        button.start_charging.prop('disabled', false);

                        if (button.book.length > 0 && window.WS.auth == true) {
                            button.book.prop('disabled', false);
                        }
                    }
                break;
                case "Preparing":
                    button.start_charging.removeClass('hide');

                    if(data.in_service == "0") {
                        if (window.user_balance >= window.min_balance) {
                            button.start_charging.attr('data-connector', connector.pk);
                            button.start_charging.attr('data-charger', data.pk);
                        }

                        button.start_charging.prop('disabled', false);
                    }
                break;
                case "Booked":
                    if(connector.book_user == window.user_pk) {

                        button.start_charging.removeClass('hide');
                        if(window.user_balance >= window.min_balance) {
                            button.start_charging.attr('data-connector', connector.pk);
                            button.start_charging.attr('data-charger', data.pk);
                        }

                        if(window.user_balance >= window.min_balance) {
                            button.start_charging.prop('disabled', false);
                        }

                        if(bookmark.hasClass('hide')) {
                            bookmark.removeClass('hide');
                        }

                    }

                    button.booked.find('span').html(connector.book_to);
                    button.booked.removeClass('hide');
                break;
                case "Faulted":
                case "Unavailable":
                    button.start_charging.removeClass('hide');

                    if(button.book.length > 0) {
                        button.book.removeClass('hide');
                    }
                break;
                case "Charging":
                case "SuspendedEV":
                case "Finishing":
                case "Parking":
                    if(connector.soc != 0) {
                        button.soc.html(connector.soc);
                        button.soc.removeClass('hide');
                    }

                    if(connector.has_client_transaction > 0) {
                        button.stop_transaction.attr('data-id', connector.has_client_transaction);
                        button.stop_transaction.removeClass('hide');
                    }
                break;
                default:
                    button.start_charging.removeClass('hide');

                    if(button.book.length > 0) {
                        button.book.removeClass('hide');
                    }
                break;
            }

            /* end buttons */
            connector_html.removeClass('hide');


            var height = connector_html.outerHeight();
            var number_layer = connector_html.find('.number');
            number_layer.css('height', height +'px');
            number_layer.css('line-height', height +'px');
            connector_html.find('.icon').css('height', height +'px');
        });

        if(window.CHARGER.layers.am_description_text.length > 0) {
            let am_description_text = window.CHARGER.layers.am_description_text.data('text');
            am_description_text = am_description_text.replace('##price##', one_electro_price);
            window.CHARGER.layers.am_description_text.html(am_description_text);
        }

        /* subnetwork */
        if(!window.CHARGER.layers.charger.subnetwork.block.hasClass('hide')) {
            window.CHARGER.layers.charger.subnetwork.block.addClass('hide');
        }
        if(!window.CHARGER.layers.charger.subnetwork.logo.hasClass('hide')) {
            window.CHARGER.layers.charger.subnetwork.logo.addClass('hide');
        }
        if(window.CHARGER.layers.charger.subnetwork.icon.hasClass('hide-default')) {
            window.CHARGER.layers.charger.subnetwork.icon.removeClass('hide-default');
        }
        window.CHARGER.layers.charger.subnetwork.name.html('');

        if(data.subnetwork.name != '') {
            window.CHARGER.layers.charger.subnetwork.name.html(data.subnetwork.name);

            if(data.subnetwork.logo != '') {
                window.CHARGER.layers.charger.subnetwork.logo.css('background-image', 'url("'+ data.subnetwork.logo +'")');

                if(window.CHARGER.layers.charger.subnetwork.logo.hasClass('hide')) {
                    window.CHARGER.layers.charger.subnetwork.logo.removeClass('hide');
                }

                if(!window.CHARGER.layers.charger.subnetwork.icon.hasClass('hide-default')) {
                    window.CHARGER.layers.charger.subnetwork.icon.addClass('hide-default');
                }
            }

            if(window.CHARGER.layers.charger.subnetwork.block.hasClass('hide')) {
                window.CHARGER.layers.charger.subnetwork.block.removeClass('hide');
            }
        }
        /* end subnetwork */

        /* tariff */
        if(!window.CHARGER.layers.charger.tariff_block.block.hasClass('hide')) {
            window.CHARGER.layers.charger.tariff_block.block.addClass('hide');
        }
        if(data.tariff_text != '') {
            window.CHARGER.layers.charger.tariff_block.text.html(data.tariff_text);

            if(window.CHARGER.layers.charger.tariff_block.block.hasClass('hide')) {
                window.CHARGER.layers.charger.tariff_block.block.removeClass('hide');
            }

            window.CHARGER.update_tariff_block_icon_height();
        }
        /* end tariff */

        /* photo */
        if(!window.CHARGER.layers.charger.photo.block.hasClass('hide')) {
            window.CHARGER.layers.charger.photo.block.addClass('hide');
        }

        var photo_HTML = '';
        $.each(data.photo, function (pk, photo) {
            photo_HTML += '<li><a href="'+ photo.url +'" data-caption="'+ photo.alt +'"><img src="'+ photo.thumb.web +'" alt="'+ photo.alt +'" loading=lazy></a></li>';
        });

        if(photo_HTML != '') {
            window.CHARGER.layers.charger.photo.photo.html(photo_HTML);

            if(window.CHARGER.layers.charger.photo.block.hasClass('hide')) {
                window.CHARGER.layers.charger.photo.block.removeClass('hide');
            }
        }
        /* end photo */

        /* comment */
        if(!window.CHARGER.layers.charger.comments.list.hasClass('hide')) {
            window.CHARGER.layers.charger.comments.list.addClass('hide');
            window.CHARGER.layers.charger.comments.list.html('');
        }
        if(window.CHARGER.layers.charger.comments.empty.hasClass('hide')) {
            window.CHARGER.layers.charger.comments.empty.removeClass('hide');
        }

        if(data.comments.length > 0) {
            var comment_HTML = '';
            $.each(data.comments, function (pk, comment) {
                switch(comment.type) {
                    case "checkin":
                        comment_HTML += '<li><div class="status"><div class="icon"><i class="fad fa-map-marker-check"></i></div><div class="date">'+ comment.date +'</div></div><div class="clear"></div><div class="text">';
                        comment_HTML += '<div class="avatar"><i class="fad fa-user-astronaut"></i></div>';
                        comment_HTML += '<div class="comment-content"><div class="comment-content-value"><i class="far fa-check-circle"></i> '+  comment.text +'</div></div><div class="clear"></div></div></li>';
                    break;
                    case "comment":
                        comment_HTML += '<li><div class="status"><div class="icon"><i class="fad fa-comment-lines"></i></div><div class="date">'+ comment.date +'</div></div><div class="clear"></div><div class="text">';
                        comment_HTML += '<div class="avatar"><i class="fad fa-user-astronaut"></i></div>';
                        comment_HTML += '<div class="comment-content"><div class="name">'+  comment.user.name +'</div><div class="comment-content-value">'+  comment.text +'</div></div><div class="clear"></div></div></li>';
                    break;
                    case "review":
                        comment_HTML += '<li><div class="status"><div class="icon"><i class="fad fa-stars"></i></div><div class="date">'+ comment.date +'</div></div><div class="clear"></div><div class="text">';
                        comment_HTML += '<div class="avatar"><i class="fad fa-user-astronaut"></i></div>';
                        comment_HTML += '<div class="comment-content"><div class="name">'+  comment.user.name +'</div><div class="rating">';

                        for(i = 1; i <= 5; i++) {
                            if(i <= comment.rating) {
                                comment_HTML += '<i class="fas fa-star"></i>';
                            } else {
                                comment_HTML += '<i class="far fa-star"></i>';
                            }
                        }

                        comment_HTML += '</div><div class="comment-content-value">'+  comment.text +'</div></div><div class="clear"></div></div></li>';
                    break;
                }
            });

            if(comment_HTML != '') {
                window.CHARGER.layers.charger.comments.list.html(comment_HTML);

                if(window.CHARGER.layers.charger.comments.list.hasClass('hide')) {
                    window.CHARGER.layers.charger.comments.list.removeClass('hide');
                }

                if(!window.CHARGER.layers.charger.comments.empty.hasClass('hide')) {
                    window.CHARGER.layers.charger.comments.empty.addClass('hide');
                }
            }
        }
        /* end comment */

        /* emergency btn */
        if(!window.CHARGER.layers.charger.emergency_btn.hasClass('hide')) {
            window.CHARGER.layers.charger.emergency_btn.addClass('hide');
        }

        if(data.emergency_btn == '1') {
            if(window.CHARGER.layers.charger.emergency_btn.hasClass('hide')) {
                window.CHARGER.layers.charger.emergency_btn.removeClass('hide');
            }
        }
        /* end emergency btn */

        /* chinaoffline btn */
        if(!window.CHARGER.layers.charger.chinaoffline.hasClass('hide')) {
            window.CHARGER.layers.charger.chinaoffline.addClass('hide');
        }

        if(data.china_offline == '1') {
            if(window.CHARGER.layers.charger.chinaoffline.hasClass('hide')) {
                window.CHARGER.layers.charger.chinaoffline.removeClass('hide');
            }
        }
        /* end chinaoffline btn */

        /* access */
        if(!window.CHARGER.layers.charger.access.hasClass('hide')) {
            window.CHARGER.layers.charger.access.addClass('hide');
            window.CHARGER.layers.charger.access_text.html('');
        }

        if(data.access_text != '') {
            if(window.CHARGER.layers.charger.access.hasClass('hide')) {
                window.CHARGER.layers.charger.access_text.html(data.access_text);
                window.CHARGER.layers.charger.access.removeClass('hide');
            }
        }
        /* end access */


        //show
        if(!window.CHARGER.layers.window.hasClass('active')) {
            window.CHARGER.layers.window.addClass('active');
        }

        if(!window.CHARGER.layers.gmap.hasClass('active_charger')) {
            window.CHARGER.layers.gmap.addClass('active_charger');
        }

        if(typeof google != 'undefined' && typeof window.gmap != 'undefined' && typeof window.gmap.setCenter != 'undefined') {
            window.gmap.setCenter(new google.maps.LatLng(data.gps.lat, data.gps.lon));
            window.gmap.setZoom(22);
        }

        if(window.CHARGER.layers.load.hasClass('active')) {
            window.CHARGER.layers.load.removeClass('active');
        }


        /* analitycs */
        if(typeof window.app != 'undefined' && window.app == 'prod' && typeof window.gtag != 'undefined') {
            window.gtag('event', 'view_item', {
                items: [{
                    id: data.pk,
                    name: data.name
                }]
            });
        }
        /* end analitycs */

        window.CHARGER.layers.charger.messages.each(function () {
            var height = $(this).outerHeight();
            var icon = $(this).find('.icon');
            icon.css('height', height +'px');
            icon.css('line-height', height +'px');
        });
    },

    update_tariff_block_icon_height: function () {
        var tarif_block_height = window.CHARGER.layers.charger.tariff_block.content.outerHeight();
        window.CHARGER.layers.charger.tariff_block.icon.css('height', tarif_block_height +'px');
        window.CHARGER.layers.charger.tariff_block.icon.css('line-height', tarif_block_height +'px');
    },

    init: function () {
        window.CHARGER.update_tariff_block_icon_height();

        window.CHARGER.layers.cross.click(function () {
            if(window.CHARGER.layers.window.hasClass('active')) {
                window.CHARGER.layers.window.removeClass('active');
            }

            if(window.CHARGER.layers.gmap.hasClass('active_charger')) {
                window.CHARGER.layers.gmap.removeClass('active_charger');
            }
        });

        window.CHARGER.layers.book.book_connector_btn.click(function () {
            if (window.WS.auth) {
                if(window.user_balance >= window.min_balance) {
                    window.WS.book_connector_tariff($(this).attr('data-connector'));
                } else {
                    window.CHARGER.layers.cross.click();
                    window.MENU.layers.items.billing.click();
                    window.NOTIFFICATIONS.open_low_balance();
                }
            } else {
                window.LOGIN.layers.map_login_btn.click();
                window.NOTIFFICATIONS.open_need_to_auth();
            }
        });

        window.CHARGER.layers.book.cross.click(function () {
            if(window.CHARGER.layers.book.window.hasClass('active')) {
                window.CHARGER.layers.book.window.removeClass('active');

                window.CHARGER.layers.book.types.min15_btn.prop('disabled', true);
                window.CHARGER.layers.book.types.min30_btn.prop('disabled', true);
                window.CHARGER.layers.book.types.min45_btn.prop('disabled', true);
                window.CHARGER.layers.book.types.hour1_btn.prop('disabled', true);

                window.CHARGER.layers.book.types.min30_price.html('');
                window.CHARGER.layers.book.types.min45_price.html('');
                window.CHARGER.layers.book.types.hour1_price.html('');
            }
        });

        window.CHARGER.layers.add_review.rating_star.click(function () {
            var rating = $(this).attr('data-value');

            window.CHARGER.layers.add_review.rating_star.removeClass('active');

            for(i=1; i<6; i++) {
                if(i <= rating) {
                    $(window.CHARGER.layers.add_review.rating_star_select + '[data-value='+ i +']').addClass('active');
                }
            }
        });

        window.CHARGER.layers.add_review.cross.click(function () {
            if(window.CHARGER.layers.add_review.window.hasClass('active')) {
                window.CHARGER.layers.add_review.window.removeClass('active');
            }
        });

        window.CHARGER.layers.add_review.form.submit(function () {
            if (!window.CHARGER.layers.load.hasClass('active')) {
                window.CHARGER.layers.load.addClass('active');
            }
            window.WS.add_review($(window.CHARGER.layers.add_review.rating_star_select+".active").length, window.CHARGER.layers.add_review.comment.val(), window.CHARGER.layers.add_review.form.attr('data-id'));
            return false;
        });

        window.CHARGER.layers.add_comment.rating_star.click(function () {
            var rating = $(this).attr('data-value');

            window.CHARGER.layers.add_comment.rating_star.removeClass('active');

            for(i=1; i<6; i++) {
                if(i <= rating) {
                    $(window.CHARGER.layers.add_comment.rating_star_select + '[data-value='+ i +']').addClass('active');
                }
            }
        });

        window.CHARGER.layers.add_comment.cross.click(function () {
            if(window.CHARGER.layers.add_comment.window.hasClass('active')) {
                window.CHARGER.layers.add_comment.window.removeClass('active');
                window.CHARGER.layers.add_comment.text.val('');
                $(window.CHARGER.layers.add_comment.rating_star_select +'[data-value=5]').click();
            }
        });

        window.CHARGER.layers.add_comment.add_comment_btn.click(function () {
            if(!window.CHARGER.layers.add_comment.window.hasClass('active')) {
                var ID = $(this).attr('data-id');
                window.CHARGER.layers.add_comment.submit_btn.attr('data-id', ID);
                window.CHARGER.layers.add_comment.window.addClass('active');
            }
        });

        window.CHARGER.layers.add_comment.form.submit(function () {
            window.WS.add_comment($(window.CHARGER.layers.add_comment.rating_star_select +'.active').length, window.CHARGER.layers.add_comment.text.val(), window.CHARGER.layers.add_comment.submit_btn.attr('data-id'));
            return false;
        });

        window.CHARGER.layers.btn.start_charging.click(function () {
                if (window.WS.auth) {
                    if(window.user_balance >= window.min_balance) {
                        if (!window.CHARGER.layers.load.hasClass('active')) {
                            window.CHARGER.layers.load.addClass('active');
                        }

                        window.WS.start_transaction($(this).attr('data-charger'), $(this).attr('data-connector'));

                        window.CHARGER.timer.start_transaction = setTimeout(function () {
                            if (window.CHARGER.layers.load.hasClass('active')) {
                                window.CHARGER.layers.load.removeClass('active');
                            }
                        }, 7000);
                    } else {
                        window.CHARGER.layers.cross.click();
                        window.MENU.layers.items.billing.click();
                        window.NOTIFFICATIONS.open_low_balance();
                    }
                } else {
                    window.LOGIN.layers.map_login_btn.click();
                    window.NOTIFFICATIONS.open_need_to_auth();
                }
        });

        window.CHARGER.layers.book.active_btn.click(function () {
            window.WS.book_connector($(this).attr('data-connetor'), $(this).attr('data-type'));
        });
    },

    update_book_data: function (data) {
        if(data.status) {

            if(window.CHARGER.layers.book.types.min15_free_count.length > 0) {
                var left = 5 - data.count;
                if (window.CHARGER.layers.book.types.min15_free_count.html() != left) {
                    window.CHARGER.layers.book.types.min15_free_count.html(left);
                }
                if (data.count < 6) {
                    window.CHARGER.layers.book.types.min15_btn.prop('disabled', false);
                    window.CHARGER.layers.book.types.min15_btn.attr('data-connetor', data.connector);
                }
            }

            if(data.data.min30 > 0) {
                window.CHARGER.layers.book.types.min30_price.html(data.data.min30 +' '+ window.currency);
            } else {
                window.CHARGER.layers.book.types.min30_price.html(data.free);
            }
            if(window.user_balance > data.data.min30) {
                window.CHARGER.layers.book.types.min30_btn.attr('data-connetor', data.connector);
                window.CHARGER.layers.book.types.min30_btn.prop('disabled', false);
            }

            if(data.data.min45 > 0) {
                window.CHARGER.layers.book.types.min45_price.html(data.data.min45 +' '+ window.currency);
            } else {
                window.CHARGER.layers.book.types.min45_price.html(data.free);
            }
            if(window.user_balance > data.data.min45) {
                window.CHARGER.layers.book.types.min45_btn.attr('data-connetor', data.connector);
                window.CHARGER.layers.book.types.min45_btn.prop('disabled', false);
            }

            if(data.data.h1 > 0) {
                window.CHARGER.layers.book.types.hour1_price.html(data.data.h1 +' '+ window.currency);
            } else {
                window.CHARGER.layers.book.types.hour1_price.html(data.free);
            }
            if(window.user_balance > data.data.h1) {
                window.CHARGER.layers.book.types.hour1_btn.attr('data-connetor', data.connector);
                window.CHARGER.layers.book.types.hour1_btn.prop('disabled', false);
            }

            if (!window.CHARGER.layers.book.window.hasClass('active')) {
                window.CHARGER.layers.book.window.addClass('active');
            }

        }
    }
};
window.CHARGER.init();
